mutation BatchTransactionUploadDocument(
  $document: DocumentUploadInput!
  $batchTransactionId: UUID!
) {
  batchTransactionUploadDocument(
    document: $document
    batchTransactionId: $batchTransactionId
  ) {
    uploadLink
    document {
      _documentFileId
      batchTransactionDocument {
        _isApprovalDocumentsRequired
        _requiredApprovalDocuments
      }
    }
  }
}
